import React from 'react'
import { Box, Grid } from '@mui/material'
import CommonButton from 'components/commonButton/CommonButton'
import CommonSDF from 'components/commonSDF/CommonSDF'
const CommonButtonSubHeader = (props) => {
  const {
    btnName,
    btnAction,
    onSelectDateRange,
    filterdata,
    onFilterChange,
    onRestFilter,
    defaultStatus,
  } = props;


  return (
    <Grid container justifyContent={'flex-end'} className="mb20">

        <Box sx={{
          flex: 1,
          display: 'flex',
          marginRight:'10px'
        }}>
          <CommonSDF
            {...props}
            onSearchQuery={props?.onSearchQuery}
            height={props?.height}
            onSelectDateRange={onSelectDateRange}
            filterIcon={'true'}
            filterdata={filterdata}
            onFilterChange={onFilterChange}
            onRestFilter={onRestFilter}
            defaultStatus={defaultStatus}
          />
        </Box>
        {btnName &&
          <Grid item justifyContent={'flex-start'}>
          <CommonButton
            name={btnName}
            btnClass={'btnMedium btnYellow'}
            iconType="add"
            iconPlace="front"
            onClick={btnAction}
          />
          </Grid>
         }
      </Grid>
  );
};

export default CommonButtonSubHeader;

